import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Dialog from '@material-ui/core/Dialog';

import { fetchMarketplaceData } from '../../../dataFetchers/marketplaceDataFetcher';
import { fetchApplianceMapping } from "../../../dataFetchers/appliancesDataFetcher";
import { getBECompatibleLocale, getBECompatibleFuelType, replaceEmailWithMailTo } from '../../../helpers/helper';
import { parseQueryParams } from '../../../helpers/URLHelper';

import Marketplace from './Marketplace';
import MarketplaceHero from './MarketplaceHero';
import { RebateDetailsModal } from './RebateDetailsModal';
import BCLLoading from '../../common/Loading/BCLLoading';

import RecoDetailsContainer from '../recoDetailsPage/RecoDetailsContainer';
import { PAGE_EVENT_NAMES, WIDGETS } from '../../../constants/common';
import { trackEvent } from '../../../helpers/analyticsHelper';
import { queryRecoCardLoaded } from '../../../actions/recoDetailsActions';
import { isPreview } from '../../../helpers/authHelper';
import { getPilotId } from '../../../helpers/userHelper';

class MarketplaceContainer extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            open: false,
            activeRecoId: null,
            rebateModalContent: null
        }
    }

    componentDidMount(){
        const configs = this.props.configs.data;
        const isPublic = this.props.isPublic;
        const pilotId = getPilotId();

        if(!this.props.marketplaceData.data) {
            let params = {
                isPublic: isPublic,
                pilotId: pilotId,
                locale: getBECompatibleLocale(configs),
                count: configs['DASHBOARD.MARKETPLACE.COUNT']
            };
            if (this.props.userIdentityDetails) {
                params['measurementType'] = getBECompatibleFuelType(this.props.userTypeDetails.measurementType);
                params['userId'] = this.props.userIdentityDetails.userId;
            }
            if (isPreview()) {
                params['templateName'] = `${WIDGETS.INSIGHTS.SHC}.FETCH_MARKETPLACE_DATA`;
            }
            this.props.fetchMarketplaceData(params);
        }

        if (isPublic) {
            let locale = getBECompatibleLocale(configs);
            let applianceIds = configs['public.applianceIds'];
            this.props.fetchApplianceMapping({isPublic, pilotId, locale, applianceIds});
        }
    }

    componentDidUpdate(){
        if(this.props.queryParams && this.props.queryParams.recoId && this.isFeatureEnabled('productEducationEnabled') && !this.props.recoDetailsData.queryCardLoaded){
            this.props.queryRecoCardLoaded();
            this.handleModal(this.props.queryParams.recoId);
        }
    }

    handleModal(recoId){
        let isModalOpen = this.state.open;
        this.setState({
            open: !isModalOpen,
            activeRecoId: recoId || null
        });

        //Track reco open/close event
        if (this.props.userIdentityDetails && this.props.userIdentityDetails.userId) {
            trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.MARKETPLACE, {
                recoID : recoId,
                open : !isModalOpen,
                close : isModalOpen
            })
        }
    }

    handleRebateModal(recoId, content) {
        let isModalOpen = this.state.open;
        this.setState({
            open: !isModalOpen,
            rebateModalContent: content || null
        });
    }

    handleCTAClick(recoId, link, rebateDetails) {
        if (rebateDetails) {
            this.handleRebateModal(recoId, replaceEmailWithMailTo(rebateDetails));
        } else if(link){
            window.open(link);
        } else{
            this.handleModal(recoId);
        }
    }

    isFeatureEnabled(feature){
        let featureKeyPrefix = this.props.isPublic ? 'public' : 'dashboard';
        return this.props.configs.data[`${featureKeyPrefix}.marketplace.${feature}`] === "true";
    }

    openPurchaseLink(itemLink){
        window.open(itemLink);
    }

    getStyles() {
        let styles = {};
        let stylesConfig = this.props.configs.data["public.marketplace.styles"];
        if (this.props.isPublic && stylesConfig) {
            styles = JSON.parse(stylesConfig);
        }
        return styles;
    }

    render(){
        const selfInstallEnabled = this.isFeatureEnabled('selfInstallEnabled');
        const marketplaceCTAEnabled = this.isFeatureEnabled('marketplaceCTAEnabled');
        const marketPlaceInsightEnabled = this.isFeatureEnabled('insightsEnabled');
        const productEducationEnabled = this.isFeatureEnabled('productEducationEnabled');

        const insightBulbImage = this.props.configs.data["DASHBOARD.RECOMMENDATIONS.INSIGHTS_BULB"];
        const styles = this.getStyles();
        const queryParams = parseQueryParams(this.props.location.search);
        const hideCTA = queryParams && queryParams["logged-in"] === "true";
        return(
            <div className={`marketplace-page ${this.props.isPublic ? 'public' : ''}`} style={styles}>
                { this.props.isPublic && <MarketplaceHero
                    configs={this.props.configs.data}
                    translations={this.props.translations}
                    hideCTA={hideCTA}
                    handleCTAClick={(link) => this.handleCTAClick(null, link)}
                /> }
                <div className="marketplace-container">
                    {this.props.marketplaceData && this.props.marketplaceData.data ?
                    <Marketplace
                        marketplaceData={this.props.marketplaceData.data}
                        selfInstallEnabled={selfInstallEnabled}
                        translations={this.props.translations}
                        marketplaceCTAEnabled={marketplaceCTAEnabled}
                        applianceList={this.props.applianceList}
                        insightBulbImage={insightBulbImage}
                        marketPlaceInsightEnabled={marketPlaceInsightEnabled}
                        productEducationEnabled={productEducationEnabled}
                        handleCTAClick={(recoId, link, rebateDetails) => this.handleCTAClick(recoId, link, rebateDetails)}
                        openPurchaseLink={(link)=>this.openPurchaseLink(link)}
                        hideTitle={this.props.isPublic} />
                    : this.props.marketplaceData.failed ? <div className="marketplace-title">{this.props.translations.data["DASHBOARD.MARKETPLACE.TITLE_FAILED"]}</div> : <BCLLoading/>}
                </div>
                {this.state.activeRecoId ?
                    <Dialog open={this.state.open} onClose={() => this.handleModal(null)} aria-labelledby="scroll-dialog-reco" maxWidth="lg" className="reco-modal">
                        <RecoDetailsContainer
                            isPublic={ this.props.isPublic }
                            onCloseClick={() => this.handleModal(null)}
                            activeReco={this.state.activeRecoId}
                            onRecoLike={(recoID, event) => this.handleRecoLikeUnlike(recoID, event)}
                            onRecoUnlike={(recoID, event) => this.handleRecoLikeUnlike(recoID, event)}
                            marketplaceCTAEnabled={marketplaceCTAEnabled}
                            openPurchaseLink={(link)=>this.openPurchaseLink(link)}/>
                    </Dialog>
                : ''}

                {this.state.rebateModalContent ?
                    <Dialog open={this.state.open} onClose={() => this.handleRebateModal()} maxWidth="md">
                        <RebateDetailsModal
                            content={this.state.rebateModalContent}
                            onCloseClick={() => this.handleRebateModal()}
                            modalClass="rebate-details-modal"/>
                    </Dialog>
                : ''}
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        userIdentityDetails: state.userIdentityDetails,
        configs: state.configs,
        translations: state.translationsData,
        queryParams: state.queryParams,
        marketplaceData : state.marketplaceData,
        applianceList: state.appliances.appliancesList,
        recoDetailsData : state.recoDetailsData,
        userTypeDetails : state.userTypeDetails
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchMarketplaceData : (params) => dispatch(fetchMarketplaceData(params)),
        queryRecoCardLoaded : () => dispatch(queryRecoCardLoaded()),
        fetchApplianceMapping: (options) => dispatch(fetchApplianceMapping(options)),
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketplaceContainer));
